import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const client = axios.create({ baseURL: API });

export async function getConfig() {
  const { data } = await client.get("/config");
  return data;
}

export async function getRoutes(category = "all") {
  const { data } = await client.get("/routes", { params: { category } });
  return data;
}

export async function geocode(text) {
  const { data } = await client.get("/geocode", { params: { text } });
  return data.items || [];
}

export async function getQuote(origin, destination, originLabel, destinationLabel) {
  const { data } = await client.post("/quote", {
    origin,
    destination,
    origin_label: originLabel,
    destination_label: destinationLabel,
  });
  return data;
}

export async function createBooking(payload) {
  const { data } = await client.post("/bookings", payload);
  return data;
}
